<div class="bg-light mt-3 no-gutters" *ngIf="deviceData; else noDeviceData">
  <div class="row pb-2 ml-2 mr-2">
    <div class="col-1 mt-1 pl-0 align-self-end">
      <img class="logo-14" src="{{getDeviceLogo(deviceData)}}" alt="logo" />
    </div>
    <div class="col-4 mt-1 pl-0">

      <!-- <div>
        <div class="font13-600">Telematics Type</div>
        <div class="font13-400 mt-1">{{vehicleData.make}}&nbsp;{{vehicleData.model}}&nbsp;</div>
      </div> -->


      <div class="w-break mt-1 font13-600">Telematics Type :
        <span *ngIf="deviceData.telematicsType; else valueNotAvailable" class="font13-400">{{deviceData.telematicsType | customText}}</span>
      </div>
      <div class="w-break mt-1 font13-600">Telematics Provider :
        <span *ngIf="deviceData.telematicsProvider; else valueNotAvailable"
          class="font13-400">{{deviceData.telematicsProvider}}</span>
      </div>
    </div>
    <div class="col-4 mt-1 pl-0">
      <div class="w-break mt-1 font13-600">Device Serial # :
        <span *ngIf="deviceData.deviceSerialNumber; else valueNotAvailable"
          class="font13-400">{{deviceData.deviceSerialNumber}}</span>
      </div>
    </div>
    <div class="col-3 mt-1 pl-0 text-right">
      <!-- <div class="d-inline-block pr-2"> -->
      <div class="d-inline-block">
        <!-- <span
            [ngClass]="{'ACTIVE':'badge-success', 'ENROLLED':'badge-success', 'INACTIVE':'badge-danger', 'PROVISIONED':'badge-warning',
                                    'PENDING':'badge-warning', 'ASSIGNED':'badge-warning', 'ORDERED':'badge-danger', 'DELIVERED':'badge-danger'}[vehicleData.status]"
            class="badge badge-pill badge-400">{{vehicleData.status | customText}}</span> -->
        <span
          [ngClass]="{'NONE':'badge-danger','ATTACHED':'badge-warning', 'ENABLED':'badge-warning', 'LINKED':'badge-success', 'UNLINKED':'badge-danger', 'DELETED':'badge-danger', 'DISABLED':'badge-danger'}[deviceData.dongleStatus]"
          class="badge badge-pill badge-400">{{deviceData.dongleStatus | customText}}</span>
        <!-- <span [ngClass]="{'NONE':'badge-danger','ATTACHED':'badge-warning', 'ENABLED':'badge-warning', 'LINKED':'badge-success', 'UNLINKED':'badge-danger'}[deviceData.dongleStatus]" class="badge badge-pill badge-400">{{deviceData.dongleStatus | customText}}</span> -->
      </div>
      <div class="w-break mt-1 font13-600 d-inline-block">

        <!-- <span class="pull-right">
            <i class="fas fa-edit cursor-pointer maroon" data-toggle="tooltip" data-placement="right" title="Edit"
              (click)="editDevice(i)"></i> &nbsp;
            <i class="fa fa-trash cursor-pointer maroon" data-toggle="tooltip" data-placement="right" title="Delete"
              (click)="deleteDevice(i)"></i>
          </span> -->
      </div>
    </div>
  </div>
</div>
<ng-template #noDeviceData>
  <div class="mt-2 font13-400">
    {{noVehicleDeviceMessage}}
  </div>
</ng-template>
<ng-template #valueNotAvailable>
  <span class="font13-400">&nbsp;-</span>
</ng-template>